import { BUILD_ID } from "@/modules/env/constants"

import { isNextDataUrlOrPathname } from "./isNextDataUrlOrPathname"

export function cleanNextDataUrlOrPathname(url: string): string {
  if (!isNextDataUrlOrPathname(url)) {
    return url
  }

  return url.replace(`/_next/data/${BUILD_ID}/`, "/").replace(".json", "")
}
